import { render, staticRenderFns } from "./ModalInventoryMSDS.vue?vue&type=template&id=4d82b434&scoped=true&"
import script from "./ModalInventoryMSDS.vue?vue&type=script&lang=js&"
export * from "./ModalInventoryMSDS.vue?vue&type=script&lang=js&"
import style0 from "./ModalInventoryMSDS.vue?vue&type=style&index=0&id=4d82b434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d82b434",
  null
  
)

export default component.exports